import React from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";
import { FormattedMessage } from "react-intl";
import { TextInput } from "../../../../common/form";
import AccountSection from "./AccountSection";
class RecievablesSection extends React.Component {
  renderProvinceFields() {
    return (
      <div className="sub-block">
        {this.props.provinces.map((item) => (
          <Field
            id={`insuranceTaxRecievable${item.provinceCode}`}
            key={item.provinceCode}
            name={`accountProvinces['${item.accountProvinceId}'].insuranceTaxRecievable`}
            component={TextInput}
            type="text"
            label={
              <FormattedMessage
                id={`common.provinces.${item.provinceCode.slice(-2)}`}
              />
            }
          />
        ))}
      </div>
    );
  }
  render() {
    return (
      <AccountSection
        title={<FormattedMessage id="admin.accounts.recievables.heading" />}
      >
        {" "}
        <fieldset>
          <div>
            <div className="sub-fields-recievables">
              <Field
                id="generalRecievableAccount"
                name="accountRecievables.generalRecievableAccount"
                component={TextInput}
                type="text"
                label={
                  <FormattedMessage id="admin.accounts.recievables.generalAccount" />
                }
              />
            </div>

            <span className="section-heading">
              {" "}
              {
                <FormattedMessage id="admin.accounts.recievables.insuranceTax" />
              }
            </span>

            {this.renderProvinceFields()}
            <span className="section-heading">
              {" "}
              {<FormattedMessage id="admin.accounts.recievables.salesTax" />}
            </span>

            <div className="sub-block">
              <Field
                id="gst"
                name="accountRecievables.gst"
                component={TextInput}
                type="text"
                label={<FormattedMessage id="admin.accounts.recievables.gst" />}
              />
              <Field
                id="qst"
                name="accountRecievables.qst"
                component={TextInput}
                type="text"
                label={<FormattedMessage id="admin.accounts.recievables.qst" />}
              />
              <Field
                id="hst"
                name="accountRecievables.hst"
                component={TextInput}
                type="text"
                label={<FormattedMessage id="admin.accounts.recievables.hst" />}
              />
            </div>
          </div>
          <div>
            <Field
              id="bonusToRecieve"
              name="accountRecievables.bonusToRecieve"
              component={TextInput}
              type="text"
              label={
                <FormattedMessage id="admin.accounts.recievables.premium" />
              }
            />
            <Field
              id="commissionAdvances"
              name="accountRecievables.commissionAdvances"
              component={TextInput}
              type="text"
              label={
                <FormattedMessage id="admin.accounts.recievables.commissions" />
              }
            />
          </div>
        </fieldset>
      </AccountSection>
    );
  }
}

RecievablesSection.propTypes = {
  provinces: PropTypes.array,
};

export default RecievablesSection;



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/accounts/formSections/RecievablesSection.js